import aframe from "aframe";
import { randomSplits } from "./wave-generator";

aframe.registerComponent("missile-times", {
  schema: {
    times: {
      default: [],
      // Comma separated vec4s
      parse: function(value) {
        return typeof value === "object"
          ? value
          : value.split(",").map(v => {
            const [time, number, splitSize, speed] = v
              .trim(" ")
              .split(" ")
              .map(s => Number.parseFloat(s));
            return {
              time,
              number,
              splitSize,
              speed
            };
          });
      }
    },
    speed: { default: 0.03 }
  },
  play() {
    if (!this.started) {
      this.el.components["wave-queue"].registerGenerator(this.iter());
      this.prevTime = 0;
      this.timer = 0;
      this.started = true;
    }
  },
  tick(t, dt) {
    this.timer += dt;
  },
  * iter() {
    let prevTime = this.timer;
    while (true) {
      if (
        !this.data.times.length ||
        this.data.times[this.data.times.length - 1].time < prevTime
      ) {
        break;
      }

      const waves = [];
      for (let i = 0; i < this.data.times.length; i++) {
        const spawnTime = this.data.times[i].time;
        if (prevTime <= spawnTime && this.timer > spawnTime) {
          const number = this.data.times[i].number;
          for (let n = 0; n < number; n++) {
            waves.push(this.missile(this.data.times[i]));
          }
        }
      }

      prevTime = this.timer;
      yield waves;
    }

    yield "done";
  },
  missile({ splitSize, speed }) {
    return {
      type: "missile",
      data: {
        speed: speed || this.data.speed,
        splitAt: randomSplits(splitSize)
      }
    };
  }
});
